import * as colors from '../../constants/Colors';

const drawerWidth = 260;

const transition = {
    transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
};

const containerFluid = {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%',
};
const container = {
    ...containerFluid,
    '@media (min-width: 576px)': {
        maxWidth: '540px',
    },
    '@media (min-width: 768px)': {
        maxWidth: '720px',
    },
    '@media (min-width: 992px)': {
        maxWidth: '960px',
    },
    '@media (min-width: 1200px)': {
        maxWidth: '1140px',
    },
};

const boxShadow = {
    boxShadow:
        '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
};

const card = {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px 0',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    borderRadius: '3px',
    color: 'rgba(0, 0, 0, 0.87)',
    background: colors.white,
};

const defaultFont = {
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    fontWeight: '300',
    lineHeight: '1.5em',
};

const primaryColor = colors.tuscany;
const secondaryColor = colors.alabaster;
const warningColor = colors.orangePeel;
const dangerColor = colors.pomegranate;
const successColor = colors.fruitSalad;
const infoColor = colors.pacificBlue;
const roseColor = colors.amaranth;
const grayColor = colors.dustyGray;

const primaryBoxShadow = {
    boxShadow:
        '0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)',
};
const infoBoxShadow = {
    boxShadow:
        '0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)',
};
const successBoxShadow = {
    boxShadow:
        '0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2)',
};
const warningBoxShadow = {
    boxShadow:
        '0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)',
};
const dangerBoxShadow = {
    boxShadow:
        '0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)',
};
const roseBoxShadow = {
    boxShadow:
        '0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)',
};

const warningCardHeader = {
    color: colors.white,
    background: `linear-gradient(60deg, ${colors.sunshade}, ${colors.pizazz})`,
    ...warningBoxShadow,
};
const successCardHeader = {
    color: colors.white,
    background: `linear-gradient(60deg, ${colors.fern}, ${colors.apple})`,
    ...successBoxShadow,
};
const dangerCardHeader = {
    color: colors.white,
    background: `linear-gradient(60deg, ${colors.burntSienna}, ${colors.cinnabar})`,
    ...dangerBoxShadow,
};
const infoCardHeader = {
    color: colors.white,
    background: `linear-gradient(60deg, ${colors.scooter}, ${colors.pacificBlue})`,
    ...infoBoxShadow,
};
const primaryCardHeader = {
    color: colors.white,
    background: `linear-gradient(60deg, ${colors.amethyst}, ${colors.seance})`,
    ...primaryBoxShadow,
};
const roseCardHeader = {
    color: colors.white,
    background: `linear-gradient(60deg, ${colors.frenchRose}, ${colors.amaranth})`,
    ...roseBoxShadow,
};
const cardActions = {
    margin: '0 20px 10px',
    paddingTop: '10px',
    borderTop: `1px solid ${colors.gallery}`,
    height: 'auto',
    ...defaultFont,
};

const cardHeader = {
    margin: '-30px 15px 0',
    borderRadius: '3px',
    padding: '15px',
};

const defaultBoxShadow = {
    border: '0',
    borderRadius: '3px',
    boxShadow:
        '0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    padding: '10px 0',
    transition: 'all 150ms ease 0s',
};

const title = {
    color: colors.oxfordBlue,
    textDecoration: 'none',
    fontWeight: '700',
    marginTop: '30px',
    marginBottom: '25px',
    minHeight: '32px',
    fontFamily: '\'Roboto Slab\', \'Times New Roman\', serif',
};

const cardTitle = {
    '&, & a': {
        ...title,
        marginTop: '.625rem',
        marginBottom: '0.75rem',
        minHeight: 'auto',
    },
};

const cardLink = {
    '& + $cardLink': {
        marginLeft: '1.25rem',
    },
};

const cardSubtitle = {
    marginBottom: '0',
    marginTop: '-.375rem',
};

const main = {
    background: colors.white,
    position: 'relative',
    zIndex: '3',
};

const mainRaised = {
    '@media (max-width: 576px)': {
        marginTop: '-30px',
    },
    '@media (max-width: 830px)': {
        marginLeft: '10px',
        marginRight: '10px',
    },
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow:
        '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
};

const section = {
    backgroundPosition: '50%',
    backgroundSize: 'cover',
};

const sectionDark = {
    backgroundColor: colors.mineShaft,
    background: `radial-gradient(ellipse at center, ${colors.scorpion} 0, ${colors.mineShaft} 100%)`,
};

const sectionDescription = {
    marginTop: '130px',
};

const description = {
    color: colors.dustyGray,
};

const mlAuto = {
    marginLeft: 'auto',
};

const mrAuto = {
    marginRight: 'auto',
};

const btnLink = {
    backgroundColor: 'transparent',
    boxShdow: 'none',
    marginTop: '5px',
    marginBottom: '5px',
};
const coloredShadow = {
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        display: 'none !important',
    },
    transform: 'scale(0.94)',
    top: '12px',
    filter: 'blur(12px)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    zIndex: '-1',
    transition: 'opacity .45s',
    opacity: '0',
};

const inputColors = {
    default: {
        textColor: colors.black,
        borderColor: colors.silver,
        backgroundColor: colors.white,
    },
    active: {
        textColor: colors.black,
        borderColor: colors.royalblue,
        backgroundColor: colors.white,
    },
    hover: {
        textColor: colors.black,
        borderColor: colors.silver,
        backgroundColor: colors.white,
    },
    disabled: {
        textColor: colors.black,
        borderColor: colors.silver,
        backgroundColor: colors.alabaster,
    },
    error: {
        textColor: colors.black,
        borderColor: colors.seaPink,
        backgroundColor: colors.white,
    },
    success: {
        textColor: colors.black,
        borderColor: colors.silver,
        backgroundColor: colors.white,
    },
};

export {
    drawerWidth,
    transition,
    container,
    containerFluid,
    boxShadow,
    card,
    defaultFont,
    primaryColor,
    secondaryColor,
    warningColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    grayColor,
    primaryBoxShadow,
    infoBoxShadow,
    successBoxShadow,
    warningBoxShadow,
    dangerBoxShadow,
    roseBoxShadow,
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    roseCardHeader,
    cardActions,
    cardHeader,
    defaultBoxShadow,
    title,
    cardTitle,
    description,
    cardLink,
    cardSubtitle,
    main,
    mainRaised,
    section,
    sectionDark,
    sectionDescription,
    mlAuto,
    mrAuto,
    btnLink,
    coloredShadow,
    inputColors,
};
